import * as React from 'react';
import { useTranslation } from 'react-i18next';
import QdDateDisplay from '../Datetime/QdDateDisplay';
import lang from '../Relations/RelationsLang';
import { IAuthorizationRelationData } from './AuthorizationDomainModel';
import { RequestControl, TableHeaderColumn, IRelationRowTable, IAllRequest, IEmployeeEntity } from '../Relations/RequestControl';
import { OptionType } from '../../controls/EmployeesComboboxMI';
import { IConfig } from './Models';
import { TableDisplayCell } from '../Relations/TableDisplayCell';
import { RenderAlert } from './RenderAlert';

interface IAutorizationRequestContentProps {
	config: IConfig,
	table: React.RefObject<RequestControl>
	name: string,
	value: string,

	blockInsert: boolean,
	blockEditRows: boolean,
	blockCloneRows: boolean,
	blockDeleteRows: boolean,
	editCurrentEmployee: boolean,

	forAcceptant: boolean,
	subordinatesTree: boolean,


	onEditClick: (event: any, row: IRelationRowTable) => void;
	onCopyClick?: (event: any, row: IRelationRowTable) => void;
	onInitData: (rows: IAllRequest) => void;

	employeeRelationsWindow: (row: OptionType) => any;
	changeEmployee: (row: IRelationRowTable, emp: OptionType) => IRelationRowTable;
	onchangedEmployee: (rows: IRelationRowTable[], emp: OptionType) => void;

	onChangedEmployees: (empl: IEmployeeEntity[]) => void,
}

export default function AutorizationRequestContent(props: IAutorizationRequestContentProps) {
	const { t } = useTranslation();
	const fields = props.config.fields;

	return <RequestControl
		ref={props.table}
		name={props.name}
		value={props.value}

		edit={!props.blockEditRows}
		copy={!props.blockCloneRows && !props.blockInsert && !props.blockEditRows}
		remove={!props.blockDeleteRows}

		onInitData={props.onInitData}
		onEditClick={props.onEditClick}
		onCopyClick={props.onCopyClick}

		classNameRow={(row: IAuthorizationRelationData) => {
			if (row.errorMessages && row.errorMessages.length > 0)
				return "row-danger";
			return "";
		}}
		editCurrentEmployee={props.editCurrentEmployee}
		employeesFilters={{
			filterId: fields.employee.filterId,
			forAcceptant: props.forAcceptant,
			subordinatesTree: props.subordinatesTree,
			maxRows: fields.employee.maxRows,
		}}

		employeeRelationsWindow={props.employeeRelationsWindow}
		changeEmployee={props.changeEmployee}
		onchangedEmployee={props.onchangedEmployee}
		onChangedEmployees={props.onChangedEmployees}
	>
		<TableHeaderColumn
			render={(row: IAuthorizationRelationData) => <RenderAlert row={row} />}
		/>
		<TableHeaderColumn
			minWidth={200}
			render={(row: IAuthorizationRelationData) => <TableDisplayCell column="resource" errorMessages={row.errorMessages} >
				{row.resource.label}
			</TableDisplayCell>}
		>
			{lang.get("toProcessOrDataSet")}
		</TableHeaderColumn>
		{!fields.level.columnHidden && <TableHeaderColumn
			minWidth={fields.level.columnMinWidth}
			render={(row: IAuthorizationRelationData) => <TableDisplayCell column="level" errorMessages={row.errorMessages} >
				{row.level && <span>{row.level.name}</span>}
			</TableDisplayCell>}
		>
			{lang.get("authorizationLevel")}
		</TableHeaderColumn>}

		{!fields.dateFrom.columnHidden && <TableHeaderColumn
			minWidth={fields.dateFrom.columnMinWidth}
			className="table-td-data"
			render={(row: IAuthorizationRelationData) => <TableDisplayCell column="from" errorMessages={row.errorMessages} >
				<QdDateDisplay value={row.from} />
			</TableDisplayCell>}
		>
			{lang.getDefaultByPrefix(fields.dateFrom, "label", "from")}
		</TableHeaderColumn>}
		{!fields.dateTo.columnHidden && <TableHeaderColumn
			minWidth={fields.dateTo.columnMinWidth}
			className="table-td-data"
			render={(row: IAuthorizationRelationData) => <TableDisplayCell column="to" errorMessages={row.errorMessages} >
				<QdDateDisplay value={row.to} />
			</TableDisplayCell>}
		>
			{lang.getDefaultByPrefix(fields.dateTo, "label", "to")}
		</TableHeaderColumn>}
	</RequestControl>
}